import { createTheme } from '@mui/material/styles';

export const appTheme = createTheme({
  palette: {
    primary: {
      main: '#1d3a4d',
    },
    secondary: {
      main: '#6a2153',
    },
    background: {
      main: '#eaeaea',
    },
    surface: {
      main: '#eaeaea',
    },
    success: {
      main: '#15543c',
    },
    error: {
      main: '#540000',
    },
  },
});
